import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle, faTimes } from "@fortawesome/free-solid-svg-icons";
import tooltipText from "../config/tooltipText";
import "../App.css"; // Ensure styles are applied

const Tooltip = ({ textKey, iconStyle = {} }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [sidebarWidth, setSidebarWidth] = useState(0);

  useEffect(() => {
    if (!isVisible) return;

    const measure = () => {
      const el = document.querySelector('.sidebar');
      const w = el && el.getBoundingClientRect ? el.getBoundingClientRect().width : 0;
      setSidebarWidth(Number.isFinite(w) ? w : 0);
    };

    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [isVisible]);

  return (
    <div className="tooltip-container">
      {/* Question Mark Icon */}
      <FontAwesomeIcon
        icon={faQuestionCircle}
        className="tooltip-icon"
        style={iconStyle}
        onClick={() => setIsVisible(true)}
      />

      {/* Modal Overlay */}
      {isVisible && (
        <div 
          className="tooltip-modal-overlay" 
          style={{
            left: sidebarWidth ? `${sidebarWidth}px` : 0,
            width: sidebarWidth ? `calc(100% - ${sidebarWidth}px)` : '100%',
          }}
          onClick={() => setIsVisible(false)}
        >
          <div className="tooltip-modal-content" onClick={(e) => e.stopPropagation()}>
            {/* Close Button in the Corner */}
            <FontAwesomeIcon
              icon={faTimes}
              className="tooltip-close-btn"
              onClick={() => setIsVisible(false)}
            />
            
            {/* Tooltip Text */}
            <div className="tooltip-modal-body">
              {tooltipText[textKey] || "Tooltip text not found"}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Tooltip;